"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
exports.ResizeHandle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n\n    // Increase the size of the clickable area\n    &:after {\n        content: '';\n        position: absolute;\n        top: -5px;\n        bottom: -5px;\n        left: -5px;\n        right: -5px;\n    }\n"], ["\n    ",
    ";\n\n    // Increase the size of the clickable area\n    &:after {\n        content: '';\n        position: absolute;\n        top: -5px;\n        bottom: -5px;\n        left: -5px;\n        right: -5px;\n    }\n"])), function (props) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        box-sizing: border-box;\n        cursor: ", ";\n        display: ", ";\n        height: ", "px;\n        margin-left: ", "px;\n        margin-top: ", "px;\n        left: ", ";\n        opacity: 0.75;\n        position: absolute;\n        top: ", ";\n        width: ", "px;\n        z-index: 100;\n        transform-origin: center;\n\n        &:hover {\n            opacity: 1;\n        }\n    "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        box-sizing: border-box;\n        cursor: ", ";\n        display: ", ";\n        height: ", "px;\n        margin-left: ", "px;\n        margin-top: ", "px;\n        left: ", ";\n        opacity: 0.75;\n        position: absolute;\n        top: ", ";\n        width: ", "px;\n        z-index: 100;\n        transform-origin: center;\n\n        &:hover {\n            opacity: 1;\n        }\n    "])), props.color, props.borderColor, exports.calculateCursor(props), props.hidden ? 'none' : 'flex', props.size, props.size / -2, props.size / -2, exports.calculateLeft, exports.calculateTop, props.size); });
exports.ResizeHandle.defaultProps = {
    borderColor: '#0000ff',
    color: '#ffffff',
    size: 5,
};
exports.default = exports.ResizeHandle;
exports.calculateLeft = function (props) {
    return props.left ? '0%' : props.right ? '100%' : '50%';
};
exports.calculateTop = function (props) {
    return props.top ? '0%' : props.bottom ? '100%' : '50%';
};
exports.calculateCursor = function (props) {
    var startingCursor = calculateStartingCursor(props);
    return adjustCursorForRotation(startingCursor, props.rotation);
};
var CURSORS = [
    'ns-resize',
    'nesw-resize',
    'ew-resize',
    'nwse-resize',
];
var calculateStartingCursor = function (props) {
    var v = props.top ? 'n' : props.bottom ? 's' : '';
    var h = props.left ? 'w' : props.right ? 'e' : '';
    var direction = "" + v + h;
    switch (direction) {
        case 'ne':
        case 'sw':
            return 'nesw-resize';
        case 'nw':
        case 'se':
            return 'nwse-resize';
        case 'e':
        case 'w':
            return 'ew-resize';
        default:
            return 'ns-resize';
    }
};
var adjustCursorForRotation = function (direction, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var cursorIndex = CURSORS.indexOf(direction);
    var indexShift = Math.round(rotation / 45);
    var newIndex = (cursorIndex + indexShift) % CURSORS.length;
    return newIndex >= 0
        ? CURSORS[newIndex]
        : CURSORS[CURSORS.length + newIndex];
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=ResizeHandle.js.map